export enum FormationsPath {
  LISTE = '',
  EDITION_SIMPLE = 'edition-formation',
  EDITION_COMPOSE = 'edition-formation-composee',
  EDITION_GENERAL = 'general',
  EDITION_GENERAL_BIS = 'general/e-catalogue',
  EDITION_SESSIONS = 'sessions',
  EDITION_PARCOURS = 'parcours',
  EDITION_PARCOURS_COMPOSE = 'parcours-composé',
  CREATION_SIMPLE = 'creation-formation',
  CREATION_COMPOSE = 'creation-formation-composée',
  ID_FORMATION_PARAM_MAP = 'idFormation',
  CREATION_SESSION = 'creation-session',
  CREATION_PARCOURS = 'creation-parcours',
  CREATION_PARCOURS_COMPOSE = 'creation-parcours-compose',
  MODULES = 'modules',
  QUESTIONNAIRE = 'questionnaire',
  EVALUATIONS = 'evaluations',
  TARIFS = 'tarifs'
}

